module.exports = __webpack_public_path__ + "static/media/qr-wexin.fd700536.jpg";